import { MFEContextResponse } from "@/lib/auth/getThirdPartyAuthProviders";
import { getEnv } from "@/env";
import Icon from "@/components/icons";
import TpaButton from "./TpaButton";
import { cn } from "@/lib/utils";

type Props = {
  isRegistration: boolean;
  tpaProviders: MFEContextResponse;
  isLogistrationV1?: boolean;
  showSsoFirst?: boolean;
};

export default function TpaGrid({
  isRegistration,
  tpaProviders,
  isLogistrationV1,
  showSsoFirst = false,
}: Props) {
  // TODO: Figure out _gl parameter
  const baseUrl = getEnv("NEXT_PUBLIC_LMS_BASE_URL");
  const title = isRegistration
    ? isLogistrationV1
      ? showSsoFirst
        ? "Sign up with:"
        : "Or sign up with:"
      : showSsoFirst
        ? "Register with:"
        : "Or register with:"
    : showSsoFirst
      ? "Sign in with:"
      : "Or sign in with:";

  return (
    <div className="mt-6">
      <h3
        className={cn(
          "text-base font-semibold mb-4",
          isLogistrationV1 ? "!text-gray-800 text-lg mt-0 font-bold" : "",
        )}
      >
        {title}
      </h3>
      {!isRegistration && (
        <a
          href={`${baseUrl}/enterprise/login`}
          className={cn(
            "inline-flex gap-1 items-center justify-center bg-transparent border border-solid border-t border-b border-l border-r border-t-transparent border-b-transparent border-l-transparent border-r-transparent rounded-none box-border text-[#454545] font-sans text-sm font-normal leading-[20px] cursor-pointer h-6 mb-6  pb-0 pl-0 pr-0 pt-0 text-left decoration-[#454545] no-underline select-none align-middle antialiased",
            isLogistrationV1
              ? "text-info-500 decoration-info-500 underline text-[16px] font-bold"
              : "",
          )}
        >
          {!isLogistrationV1 ? (
            <Icon
              type="institution"
              svgProps={{ width: 18, height: 18, fill: "#707070" }}
            />
          ) : null}
          Company or school credentials
        </a>
      )}
      <div className="flex flex-wrap gap-4">
        {tpaProviders.contextData.providers.map((provider, index) => (
          <TpaButton
            key={provider.id}
            provider={provider}
            isRegistration={isRegistration}
            baseUrl={baseUrl}
            index={index}
            isLogistrationV1={isLogistrationV1}
          />
        ))}
      </div>
    </div>
  );
}
